import React, { ReactElement, useEffect, useState } from 'react';
import { User, FetchedVCData } from 'types/Types';
import styled, { css } from 'styled-components';
import { ListHarvest } from 'ui/organisms/List/Harvest';
import { CreatePickup } from 'ui/organisms/CreatePickup';
import { ListUsers } from 'ui/organisms/List/Users';
import { ConfirmPickupCreation } from 'ui/organisms/ConfirmPickupCreation';
import { Button } from 'ui/atoms/Button';
import useStep from 'hooks/useStep';
import { useApiState } from 'hooks/useApiState';
import { LoadingAnimationWrapper } from 'ui/molecules/LoadingAnimationWrapper';
import { useAuth } from 'contexts/AuthContext';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import SuccessMessage from 'ui/molecules/SuccessMessage/SuccessMessage';
import { useHistory } from 'react-router-dom';
import { Title } from 'ui/atoms/Title';
import { getRecipients, getVCDataSled2 } from '../../../../services/sled2-api';
import { useTranslation } from 'react-i18next';

const PickupNew = (): ReactElement => {
    const { t } = useTranslation();
    const history = useHistory();
    const { currentUser } = useAuth();
    const { step, stepInc, stepDec } = useStep();
    const [users, setUsers] = useState<User[]>([]);
    const [selectedUser, setSelectedUser] = useState<number | null>(null);
    const [fetchedVCData, setFetchedVCData] = useState<FetchedVCData[]>([]);
    const [selectedFetchedVCData, setSelectedFetchedVCData] = useState<string[]>([]);
    const [harvestData, setHarvestData] = useState<FetchedVCData[]>([]);
    const [userData, setUserData] = useState<User | null>(null);
    const [proofData, setProofData] = useState<FetchedVCData[]>([]);
    const { loading, error, success, setLoading, setError, setSuccess } = useApiState();
    const [txLink, setTxLink] = useState<string | null>(null);

    const getUserFromId = () => {
        let data = null;
        if (selectedUser === null) return data;
        for (let i = 0; i < users.length; i++) {
            console.log('Users:', users[i]._id);
            console.log('Selected User:', selectedUser);
            if (users[i]._id === selectedUser) {
                data = users[i];
                break;
            }
        }
        return data;
    };

    const getData = () => {
        setLoading(true);
        getRecipients()
            .then((res) => {
                console.log('Recipients users:', res);
                setUsers(res);
            })
            .catch((err) => console.log('getRecipients error: ', err));
        getVCDataSled2()
            .then((res) => {
                setFetchedVCData(res);
            })
            .catch((err) => {
                console.log(err.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        console.log('Selected USER: ', selectedUser);
        setUserData(getUserFromId());
    }, [selectedUser]);

    useEffect(() => {
        console.log('USER Data setted: ', userData);
    }, [userData]);
    return (
        <LoadingAnimationWrapper loading={loading}>
            <PickupWrapper>
                {!error && (
                    <>
                        {!success && (
                            <>
                                <ContainerMain>
                                    {step === 0 && fetchedVCData.length > 0 && (
                                        <PickupWrapper>
                                            <Title text={t('pickupNew.title')} subtext={t('pickupNew.searchHarvest')} />
                                            <ListHarvest
                                                fetchedHarvestData={fetchedVCData}
                                                selected={selectedFetchedVCData}
                                                setSelected={setSelectedFetchedVCData}
                                            />
                                        </PickupWrapper>
                                    )}
                                    {step === 1 && (
                                        <PickupWrapper>
                                            <Title
                                                text={t('pickupNew.title')}
                                                subtext={t('pickupNew.searchPickupUser')}
                                            />
                                            <ListUsers
                                                users={users}
                                                selected={selectedUser}
                                                onSelectionChanged={setSelectedUser}
                                            />
                                        </PickupWrapper>
                                    )}
                                    {step === 2 && harvestData && (
                                        <PickupWrapper>
                                            <Title text={t('pickupNew.title')} subtext={t('pickupNew.fillPickup')} />
                                            <CreatePickup
                                                selectedFetchedVCData={selectedFetchedVCData}
                                                fetchedVCData={fetchedVCData}
                                                harvestData={harvestData}
                                                setHarvestData={setHarvestData}
                                                setProofData={setProofData}
                                            />
                                        </PickupWrapper>
                                    )}
                                    {step === 3 && harvestData.length > 0 && userData && (
                                        <PickupWrapper>
                                            <Title text={t('pickupNew.title')} subtext={t('pickupNew.confirmPickup')} />
                                            <ConfirmPickupCreation
                                                harvestData={harvestData}
                                                proofData={proofData}
                                                user={userData}
                                                setSuccess={setSuccess}
                                                setLoading={setLoading}
                                                setError={setError}
                                                setTxLink={setTxLink}
                                            />
                                        </PickupWrapper>
                                    )}
                                </ContainerMain>
                                <ContainerBottom>
                                    <ContainerButton pos="left">
                                        <Button
                                            onClick={stepDec}
                                            disabled={step === 0}
                                            iconPosition="left"
                                            icon={<GoArrowLeft />}
                                            text={t('navigation.back')}
                                            btnType="primary"
                                        />
                                    </ContainerButton>
                                    <ContainerButton pos="right">
                                        <Button
                                            onClick={stepInc}
                                            disabled={
                                                selectedFetchedVCData === null ||
                                                selectedFetchedVCData.length === 0 ||
                                                (step === 1 && selectedUser === null) ||
                                                step === 3
                                            }
                                            iconPosition="right"
                                            icon={<GoArrowRight />}
                                            text={t('navigation.next')}
                                            btnType="primary"
                                        />
                                    </ContainerButton>
                                </ContainerBottom>
                            </>
                        )}
                        {success && (
                            <>
                                <SuccessMessage message={t('pickupNew.successMessage')} txLink={txLink} />
                                <Button
                                    text={t('navigation.moveToAHome')}
                                    onClick={() => history.push('/')}
                                    btnType="primary"
                                />
                            </>
                        )}
                    </>
                )}
            </PickupWrapper>
        </LoadingAnimationWrapper>
    );
};

export default PickupNew;

const PickupWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 20px;
`;

const ContainerMain = styled.div`
    display: flex;
    flex: 1 1 auto;
    overflow-y: hidden;
    overflow-x: hidden;
`;

const ContainerBottom = styled.div`
    display: flex;
    margin-top: 30px;
`;

const ContainerButton = styled.div<{ pos: 'left' | 'right' }>`
    width: 100%;
    ${({ pos }) =>
        (pos === 'left' &&
            css`
                margin-right: 5px;
            `) ||
        (pos === 'right' &&
            css`
                margin-left: 5px;
            `)}
`;
